export default `
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="50pt" height="50pt" viewBox="0 0 150.000000 194.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,194.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M1054 1674 c-37 -24 -80 -79 -76 -96 1 -5 -2 -8 -6 -8 -5 0 -15 -19
-22 -42 -8 -24 -20 -52 -27 -63 -7 -11 -13 -26 -13 -35 0 -8 -11 -37 -25 -63
-14 -26 -23 -52 -20 -58 4 -5 -3 -17 -15 -27 -11 -9 -22 -26 -24 -37 -3 -18
-8 -21 -36 -16 -5 0 -10 20 -10 44 0 43 -32 127 -48 127 -5 0 -15 11 -22 25
-7 14 -19 25 -27 25 -7 0 -12 3 -11 8 2 4 -12 23 -30 43 -34 38 -71 50 -167
54 -64 3 -121 -29 -108 -61 3 -8 0 -14 -6 -14 -13 0 -5 -182 9 -208 5 -9 16
-38 26 -64 9 -26 27 -62 40 -80 13 -17 24 -38 24 -46 0 -7 5 -10 11 -6 14 9 2
55 -21 76 -10 9 -26 38 -36 65 -9 26 -21 52 -26 58 -4 5 -8 27 -8 50 -1 22 -5
59 -9 82 -4 23 -4 46 0 50 5 5 10 21 11 37 1 15 11 32 22 38 27 15 116 11 158
-7 20 -8 38 -12 41 -9 3 3 18 -12 33 -33 16 -21 44 -54 61 -73 18 -19 33 -40
33 -47 0 -6 4 -13 8 -15 14 -5 38 -154 31 -182 -8 -28 13 -60 34 -53 7 2 21
30 33 63 12 32 42 103 67 157 26 53 44 97 42 97 -3 0 12 35 31 78 20 42 37 83
38 90 1 7 20 27 41 45 50 41 120 44 160 7 14 -13 25 -19 25 -15 0 5 7 -1 16
-13 9 -13 14 -26 11 -29 -3 -2 1 -22 8 -44 8 -22 10 -41 5 -44 -5 -3 -6 -13
-3 -22 4 -9 2 -14 -3 -10 -6 3 -10 -18 -10 -51 -1 -52 -35 -181 -56 -208 -4
-6 -5 -14 -2 -17 4 -4 -1 -18 -10 -32 -9 -14 -14 -25 -10 -25 4 0 1 -7 -6 -15
-6 -8 -9 -19 -5 -25 3 -5 -2 -22 -13 -38 -28 -39 -45 -94 -32 -102 6 -4 8 -14
4 -23 -4 -10 5 -27 25 -46 17 -17 31 -34 31 -38 0 -5 8 -16 18 -25 30 -29 42
-47 42 -63 0 -9 7 -27 16 -41 10 -14 17 -47 18 -78 0 -30 4 -52 9 -49 13 8 7
-16 -14 -52 -16 -27 -19 -38 -10 -49 7 -8 8 -16 3 -18 -11 -3 -72 -131 -72
-148 0 -6 -4 -9 -9 -5 -5 3 -16 -3 -23 -13 -14 -19 -119 -72 -152 -76 -12 -1
-28 -5 -36 -9 -23 -9 -190 -14 -190 -5 0 4 -13 8 -29 8 -25 0 -28 3 -23 28 6
36 28 52 62 46 15 -3 43 -1 64 4 32 9 40 8 56 -8 10 -10 16 -21 12 -24 -3 -3
0 -6 6 -6 7 0 13 9 13 20 3 41 4 45 19 45 8 0 29 6 47 13 29 13 34 12 66 -12
19 -14 37 -26 40 -26 14 0 6 28 -13 45 -19 17 -19 52 0 65 4 3 12 15 19 27 8
17 18 21 41 18 41 -5 46 10 9 25 -20 9 -28 18 -24 27 14 38 16 63 6 63 -6 0
-12 -8 -13 -17 0 -10 -2 -23 -2 -30 -2 -22 -24 -37 -38 -26 -18 15 -67 22 -74
11 -3 -5 13 -16 35 -25 47 -18 50 -31 18 -61 -28 -26 -31 -27 -52 -6 -13 13
-19 14 -28 5 -9 -10 -8 -16 7 -27 11 -7 18 -15 15 -17 -27 -20 -61 -37 -74
-37 -9 0 -22 14 -29 30 -15 36 -27 29 -20 -10 7 -32 -11 -40 -88 -40 -52 0
-56 7 -38 55 9 24 8 25 -11 14 -12 -6 -24 -19 -26 -29 -6 -24 -30 -33 -37 -14
-3 8 -10 14 -16 14 -14 0 -50 32 -50 45 0 6 16 26 36 45 23 21 32 36 24 38 -7
3 -15 0 -19 -5 -3 -4 -19 -16 -34 -26 -15 -10 -25 -22 -22 -27 3 -5 -3 -8 -14
-7 -11 1 -18 3 -16 5 2 2 -5 20 -15 40 -11 19 -17 39 -14 44 3 4 1 8 -4 8 -17
0 -20 -60 -4 -69 12 -7 14 -19 9 -55 -6 -45 -1 -56 19 -36 10 10 54 3 54 -10
0 -4 18 -15 40 -25 22 -10 40 -23 40 -29 0 -26 -27 -60 -47 -61 -12 -1 -20 2
-17 7 5 8 0 10 -28 12 -7 1 -15 3 -18 6 -3 3 -27 21 -55 39 -27 19 -53 41 -58
47 -4 7 -13 19 -20 26 -29 29 -57 106 -62 173 -12 126 37 303 111 410 20 28
17 56 -10 89 -27 32 -41 22 -22 -15 15 -30 31 -90 18 -71 -7 11 -11 11 -19 0
-10 -13 -25 -50 -29 -77 -2 -7 -7 -18 -13 -24 -6 -6 -11 -19 -11 -30 0 -10 -7
-25 -16 -34 -8 -9 -14 -30 -13 -47 1 -17 -1 -38 -4 -46 -21 -56 -12 -222 15
-288 6 -15 12 -34 14 -42 10 -49 180 -154 290 -178 60 -13 276 -4 303 12 7 5
14 6 17 3 3 -2 37 12 77 32 56 29 79 47 104 85 18 26 30 53 27 58 -4 6 -1 14
6 18 12 8 55 160 54 195 -1 47 -18 123 -37 170 -22 52 -34 68 -80 115 -40 42
-44 78 -14 152 52 130 93 264 101 333 3 22 10 64 16 94 15 82 12 110 -17 157
-49 76 -153 98 -229 48z"/>
<path d="M689 963 c-30 -8 -44 -53 -44 -144 0 -48 2 -89 5 -92 3 -2 15 -7 26
-11 18 -5 26 1 48 39 30 50 37 135 17 188 -10 26 -18 29 -52 20z"/>
<path d="M892 843 c-38 -48 -26 -94 26 -95 39 -1 58 14 66 53 13 68 -49 96
-92 42z"/>
<path d="M1126 672 c-3 -6 1 -15 9 -22 12 -10 13 -16 4 -27 -7 -8 -18 -12 -25
-9 -7 3 -18 -2 -25 -10 -10 -12 -14 -12 -20 -2 -6 9 -9 8 -9 -6 0 -17 6 -18
50 -13 73 9 130 28 130 44 0 10 -6 12 -22 7 -40 -12 -51 -10 -58 15 -6 26 -24
38 -34 23z"/>
</g>
</svg>
`
